import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { NavController, ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

// import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
let UiCPixAdvertisementModalComponent = class UiCPixAdvertisementModalComponent {
    constructor(navCtrl, modalController) {
        this.navCtrl = navCtrl;
        this.modalController = modalController;
        // this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    }
    ngOnInit() { }
    dismiss() {
        this.modalController.dismiss();
    }
    continue() {
        this.dismiss();
        this.navCtrl.navigateRoot([this.pixRoute]);
    }
};
UiCPixAdvertisementModalComponent.ctorParameters = () => [
    { type: NavController },
    { type: ModalController }
];
__decorate([
    Input()
], UiCPixAdvertisementModalComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input()
], UiCPixAdvertisementModalComponent.prototype, "pixRoute", void 0);
UiCPixAdvertisementModalComponent = __decorate([
    Component({
        selector: 'ui-c-pix-advertisement-modal',
        template: "<div class=\"ui-c-pix-advertisement-modal-container\">\n  <div class=\"header-banner\" [style.background-image]=\"'url(' + backgroundImage + ')'\">\n    <div class=\"close-button-container\" (click)=\"dismiss()\">\n      <ion-icon name=\"close-outline\"></ion-icon>\n    </div>\n    <div class=\"pix-advertisement-text\">\n      <span class=\"font-family-bold first-description d-block font-size-38\">\n        {{\"PIX.PIX_ADVERTISEMENT_MODAL.FIRST_DESCRIPTION\" | wlpTranslate}}\n        <!-- Com Pix, receba e envie em segundos -->\n      </span>\n      <span class=\"second-description font-size-24\">\n        {{\"PIX.PIX_ADVERTISEMENT_MODAL.SECOND_DESCRIPTION\" | wlpTranslate}}\n        <!-- Sem precisar usar um monte de dados, transfira para qualquer banco, qualquer hora. Deixe tudo pronto para usar o Pix -->\n      </span>\n    </div>\n  </div>\n  <div class=\"pix-footer\">\n    <ion-button (click)=\"continue()\" expand=\"block\" class=\"register-button font-family-bold text-align-center\"\n      fill=\"clear\">\n      <!-- Registrar no Pix -->\n      {{\"PIX.PIX_ADVERTISEMENT_MODAL.BUTTON\" | wlpTranslate}}\n    </ion-button>\n  </div>\n</div>"
    })
], UiCPixAdvertisementModalComponent);

let UiCPixAdvertisementModalModule = class UiCPixAdvertisementModalModule {
};
UiCPixAdvertisementModalModule = __decorate([
    NgModule({
        declarations: [UiCPixAdvertisementModalComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCPixAdvertisementModalComponent]
    })
], UiCPixAdvertisementModalModule);

/*
 * Public API Surface of ui-c-pix-advertisement-modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPixAdvertisementModalComponent, UiCPixAdvertisementModalModule };
//# sourceMappingURL=wlp-ui-c-pix-advertisement-modal.js.map
